/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Candidate_Profile_Services_PlaceholderInputs */

const en_candidate_profile_services_placeholder = /** @type {(inputs: Candidate_Profile_Services_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g., Software Development, Consulting`)
};

const de_candidate_profile_services_placeholder = /** @type {(inputs: Candidate_Profile_Services_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Softwareentwicklung, Beratung`)
};

/**
* | output |
* | --- |
* | "e.g., Software Development, Consulting" |
*
* @param {Candidate_Profile_Services_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const candidate_profile_services_placeholder = /** @type {((inputs?: Candidate_Profile_Services_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Candidate_Profile_Services_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_candidate_profile_services_placeholder(inputs)
	return en_candidate_profile_services_placeholder(inputs)
});